<template>
  <svg aria-hidden="true" viewBox="0 0 1200 1200" ...attributes>
    <path fill="#63CC98" d="M580.5 500v-380c0-11 9-20 20-20s20 9 20 20v380h-40z"></path>
    <path
      fill="#1B2D3C"
      d="M936.1 500l150-100-336.1-224-90 60v48l90-60 263.9 176-113.9 76-240-160v48l203.9 136-263.9 176-263.9-176 203.9-136v-48l-240 160-113.9-76 263.9-176 90 60v-48l-90-60-336.1 224 150 100-150 100 166.1 110.7v169.3c0 11 9 20 20 20s20-9 20-20v-142.6l130 86.6 130-86.7v342.7c0 11 9 20 20 20s20-9 20-20v-342.6l130 86.6 130-86.7v142.7c0 11 9 20 20 20s20-9 20-20v-169.3l166.1-110.7-150-100zm-486.1 276l-263.9-176 113.9-76 263.9 176-113.9 76zm186.1-76l263.9-176 113.9 76-263.9 176-113.9-76z"
    ></path>
    <path
      fill="#7DB9D8"
      d="M660 410v48.1l62.9 41.9-122.9 81.9-122.9-81.9 62.9-41.9v-48.1l-135 90 195 130 195-130z"
    ></path>
  </svg>
</template>
